
// import { Component } from "react";
// import React from "react";
// import { Link } from "react-router-dom";
// import Navbar from "../../Home/Components/Nav";
// import Footer from "../../Home/Components/Footer";
// import "bootstrap/dist/css/bootstrap.min.css";
// import Contactus from "../../contact/Container/Contactformcon";
// import ReusableImageSections from "../../MgComet/CometImageSections";

// const windsorImages = [
//   // BANNER IMAGE (FIRST IMAGE)
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Home%2FBanner%2Fwindsor-bn-dsc-011.webp?alt=media&token=3fcb25e1-d6e6-4ece-b052-4ab4d66e6f1f",

//   // OTHER IMAGES
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-bn-dsc-007.webp?alt=media&token=b775faa6-57de-45a5-be27-8ea1b5c2a283",
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-bn-dsc-013.webp?alt=media&token=37830496-876f-4f0e-aaea-4395139c8074",
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-bn-dsc-009.webp?alt=media&token=ea0c1a6c-b6aa-447d-8f73-fabd819df8be",
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-bn-dsc-010.webp?alt=media&token=0975958e-ceb4-4e9a-b66d-e8ae563d9cbd",
// ];

// class Windsorevinspire extends Component {
//   render() {
//     return (
//       <div id="container">
//         <Navbar />

//         {/* INTERNAL CSS */}
//         <style>{`
//           .breadcrumb-section {
//             background: #f5f5f5;
//             padding: 12px 50px;
//             font-size: 14px;
//           }

//           .breadcrumb-section a {
//             text-decoration: none;
//             color: grey;
//           }

//           .breadcrumb-current {
//             color: #000;
//             font-weight: 500;
//           }
//         `}</style>

//         {/* BANNER IMAGE ONLY */}
//         <ReusableImageSections images={[windsorImages[0]]} />

//         {/* BREADCRUMB BELOW BANNER */}
//         <div className="breadcrumb-section">
//           <Link to="/">Home</Link>
//           <span> &nbsp;/&nbsp; </span>
//           <span className="breadcrumb-current">
//             MG Windsor Ev Inspire
//           </span>
//         </div>

//         {/* REMAINING IMAGES */}
//         <ReusableImageSections images={windsorImages.slice(1)} />

//         <Contactus someValue="Commit" />
//         <Footer />
//       </div>
//     );
//   }
// }

// export default Windsorevinspire;






















import { Component } from "react";
import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../Home/Components/Nav";
import Footer from "../../Home/Components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import Contactus from "../../contact/Container/Contactformcon";
import ReusableImageSections from "../../MgComet/CometImageSections";

const windsorImages = [
  // BANNER IMAGE
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Home%2FBanner%2Fwindsor-bn-dsc-011.webp?alt=media&token=3fcb25e1-d6e6-4ece-b052-4ab4d66e6f1f",

  // OTHER IMAGES
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-bn-dsc-007.webp?alt=media&token=b775faa6-57de-45a5-be27-8ea1b5c2a283",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-bn-dsc-013.webp?alt=media&token=37830496-876f-4f0e-aaea-4395139c8074",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-bn-dsc-009.webp?alt=media&token=ea0c1a6c-b6aa-447d-8f73-fabd819df8be",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-bn-dsc-010.webp?alt=media&token=0975958e-ceb4-4e9a-b66d-e8ae563d9cbd",
];

class Windsorevinspire extends Component {
  render() {
    return (
      <div id="container">
        <Navbar />

        {/* INTERNAL CSS */}
        <style>{`
          .breadcrumb-section {
            background: #f5f5f5;
            padding: 12px 50px;
            font-size: 14px;
          }

          .breadcrumb-section a {
            text-decoration: none;
            color: grey;
          }

          .breadcrumb-current {
            color: #000;
            font-weight: 500;
          }

          .video-section {
            width: 100%;
            // padding: 40px 50px;
            background: #000;
          }

          .video-wrapper {
            max-width: 1200px;
            margin: 0 auto;
          }

          .video-wrapper video {
            width: 100%;
            height: 70vh;
            border-radius: 10px;
          }
        `}</style>

        {/* BANNER IMAGE */}
        <ReusableImageSections images={[windsorImages[0]]} />

        {/* BREADCRUMB */}
        <div className="breadcrumb-section">
          <Link to="/">Home</Link>
          <span> &nbsp;/&nbsp; </span>
          <span className="breadcrumb-current">
            MG Windsor Ev Inspire
          </span>
        </div>

        {/* VIDEO SECTION */}
        <div className="video-section">
          <div className="video-wrapper">
            <video
              controls
              autoPlay
              muted
              loop
              playsInline
              poster="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-vd-dsc-001.mp4?alt=media&token=aca485db-3890-4a85-80f4-b76e5a5f63aa"
            >
              <source
                src="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/WINDSOREVINSPIRE%2Fwindsor-vd-dsc-001.mp4?alt=media&token=aca485db-3890-4a85-80f4-b76e5a5f63aa"
                type="video/mp4"
              />
             
            </video>
          </div>
        </div>

        {/* REMAINING IMAGES */}
        <ReusableImageSections images={windsorImages.slice(1)} />

        <Contactus someValue="Commit" />
        <Footer />
      </div>
    );
  }
}

export default Windsorevinspire;

